export const grayGradient = "linear-gradient(0deg, #f3f3f3 0%, #ffffff 100%)";
export const grayGradient2 =
  "linear-gradient(0deg, #f3f3f3 0%, #dadada 98.34%)";
export const grayGradient3 =
  "linear-gradient(180deg,rgba(255, 255, 255, 0.0966455) 0%,rgba(255, 255, 255, 0.0001) 100%)";

export const grayShadow = "0px 3px 3px rgba(0, 0, 0, 0.196706)";
export const grayShadowLight = "0 0px 0px 20px rgba(255,255,255,0.05)";

export const blackRadial =
  "radial-gradient(134.34% 134.34% at 50% 0%, #1F3757 0%, #131537 100%);";

export const blue = "#2a45c2";
export const blueDark = "#3B4262";

export const white = "#fff";

export const gray = "rgba(255, 255, 255, 0.289199)";
export const grayDark = "#565468";
export const grayDark2 = "#babfd4";
export const grayLight = "#f3f3f3";
export const grayLight2 = "#dadada";
